import type {AnalysisOptions} from "../AnalysisOptions.ts";
import type {Setter} from "../../../util/setter/Setter.ts";
import {useFieldSetter} from "../../../util/setter/FieldSetter.ts";
import {SuspenseLayer} from "../../../util/suspense/SuspenseLayer.tsx";
import {ProjectSelector} from "./ProjectSelector.tsx";
import {CheckboxField} from "../../../components/checkbox-field/CheckboxField.tsx";

interface Props {
    options: AnalysisOptions
    setOptions: Setter<AnalysisOptions>
}
export function ProjectOptionsBlock({options, setOptions}: Props) {
    const [project, setProject] = useFieldSetter(options, setOptions, "analyseProjects")
    return <div>
        <CheckboxField value={project.analyzeAll}
                       setValue={(newValue)=>setProject(old =>({...old, analyzeAll: newValue}))}
                       title={"Analyze all projects"}
                       description={project.analyzeAll ? "The default version in every project will be analyzed" : "Please select which project versions to analyze"}
                       small
                   />
        {!project.analyzeAll && <SuspenseLayer><ProjectSelector project={project} setProject={setProject} /></SuspenseLayer> }
    </div>
}